module.exports = __webpack_public_path__ + "static/media/SM_Intro-AFTER-trial.7f786554.mp3";